
export type MathArity = 1 | 2;

export type MathOpSpec = {
	op: string;
	arity: MathArity;
	label: { en: string; fr: string };

	desc: { en: string; fr: string };
};

export const MATH_REGISTRY: readonly MathOpSpec[] = [
	{
		op: "Add",
		arity: 2,
		label: { en: "Add (a + b)", fr: "Addition (a + b)" },
		desc: { en: "Returns a + b.", fr: "Renvoie a + b." },
	},
	{
		op: "Sub",
		arity: 2,
		label: { en: "Subtract (a − b)", fr: "Soustraction (a − b)" },
		desc: { en: "Returns a − b.", fr: "Renvoie a − b." },
	},
	{
		op: "Mul",
		arity: 2,
		label: { en: "Multiply (a × b)", fr: "Multiplication (a × b)" },
		desc: { en: "Returns a × b.", fr: "Renvoie a × b." },
	},
	{
		op: "Div",
		arity: 2,
		label: { en: "Divide (a ÷ b)", fr: "Division (a ÷ b)" },
		desc: {
			en: "Returns a ÷ b. Falls back to nil when b == 0.",
			fr: "Renvoie a ÷ b. Renvoie nil quand b == 0.",
		},
	},
	{
		op: "Min",
		arity: 2,
		label: { en: "Minimum (min(a, b))", fr: "Minimum (min(a, b))" },
		desc: { en: "Returns the smaller value.", fr: "Renvoie la plus petite valeur." },
	},
	{
		op: "Max",
		arity: 2,
		label: { en: "Maximum (max(a, b))", fr: "Maximum (max(a, b))" },
		desc: { en: "Returns the larger value.", fr: "Renvoie la plus grande valeur." },
	},
	{
		op: "Abs",
		arity: 1,
		label: { en: "Absolute (|a|)", fr: "Valeur absolue (|a|)" },
		desc: { en: "Returns |a|.", fr: "Renvoie |a|." },
	},
	{
		op: "Floor",
		arity: 1,
		label: { en: "Floor (⌊a⌋)", fr: "Plancher (⌊a⌋)" },
		desc: { en: "Rounds a down to the nearest integer.", fr: "Arrondit a vers le bas." },
	},
	{
		op: "Ceil",
		arity: 1,
		label: { en: "Ceil (⌈a⌉)", fr: "Plafond (⌈a⌉)" },
		desc: { en: "Rounds a up to the nearest integer.", fr: "Arrondit a vers le haut." },
	},
	{
		op: "Round",
		arity: 1,
		label: { en: "Round", fr: "Arrondi" },
		desc: { en: "Rounds a to the nearest integer.", fr: "Arrondit a au plus proche." },
	},
];

const MATH_OP_BY_NAME: Record<string, MathOpSpec> = Object.fromEntries(
	MATH_REGISTRY.map((m) => [m.op, m]),
);

export const MATH_OPS: readonly string[] = MATH_REGISTRY.map((m) => m.op);

export const getMathOpSpec = (op: string): MathOpSpec | undefined =>
	MATH_OP_BY_NAME[op];

export const isValidMathOp = (op: string): boolean => op in MATH_OP_BY_NAME;
